/**
 * ============================================================================
 * USER SERVICE: Live Chat & WhatsApp Conversations API
 * ============================================================================
 */

import api from "../../core/services/api";

const chatService = {
  /**
   * Fetches conversation threads
   * @param {Object} params - { q, filter }
   */
  getConversations: async (params = {}) => {
    return api.get("/chat/conversations", { params });
  },

  /**
   * Fetches full chat history for a customer contact phone number
   * @param {string} contactPhone
   */
  getMessages: async (contactPhone) => {
    return api.get(`/chat/messages/${encodeURIComponent(contactPhone)}`);
  },

  /**
   * Sends an outbound chat message
   * @param {Object} payload - { to, message, messageType, mediaUrl, businessNumber }
   */
  sendMessage: async (payload) => {
    return api.post("/chat/send", payload);
  },

  /**
   * Uploads a chat media attachment
   * @param {File} file
   */
  uploadMedia: async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return api.post("/chat/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  /**
   * Toggles pin status for a conversation thread
   * @param {string} conversationId
   * @param {boolean} isPinned
   */
  togglePin: async (conversationId, isPinned) => {
    return api.put(`/chat/conversations/${conversationId}/pin`, { isPinned });
  },

  /**
   * Marks a conversation thread as read
   * @param {string} conversationId
   */
  markAsRead: async (conversationId) => {
    return api.put(`/chat/conversations/${conversationId}/read`);
  },
};

export default chatService;
